import styled, { css } from 'styled-components';
import { mediaQuery } from '~/src/styles/mixins';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { rem } from '~/src/helpers/rem-converter.helper';
import { Z_INDEX } from '~/src/styles/tokens/z-index';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';
import { MAX_567 } from '~/src/styles/tokens/break-points';
import type { BadgeContainerProps } from '~/src/components/common-components/info-badge/info-badge.types';

export const OuterContainer = styled.div<{ shift: number; top?: number; }>`
    position: fixed;
    justify-content: flex-start;
    align-items: center;
    top: ${(p) => (p.top && p.top > 0 ? rem(p.top) : rem(100))};
    left: calc(50% - ${p => rem(p.shift)});
    z-index: ${Z_INDEX.level5};

    ${(p) => p.shift && css`
        ${mediaQuery(
        { maxWidth: MAX_567 },
        css`
            left: calc((50% - ${rem(p.shift)}) / 2);
        `,
    )}
  `}
`;

export const BadgeContainer = styled.div<BadgeContainerProps>`
    display: grid;
    grid-template-columns: min-content auto;
    align-items: center;
    padding: ${rem(8)} ${rem(12)};
    background-color: ${(p) => p.backgroundColor};
    color: ${(p) => p.textColor};
    border-radius: ${BORDER_RADIUS.bigger12};
    ${FONTS.compact.regular.size14};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    opacity: ${(p) => (p.isVisible ? 1 : 0)};
    transition: opacity 0.3s ease-out;
`;

export const IconWrapper = styled.div`
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${rem(24)};
    height: ${rem(24)};
`;

export const BadgeText = styled.span``;
